import React, { useState } from 'react';
import { ClipboardList, PiggyBank } from 'lucide-react';

import CofrinhoRegistro from './CofrinhoRegistro';
import CofrinhoConsulta from './CofrinhoConsulta';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

// =====================================================================
// FINANCEIRO — Cofrinho: a CASCA do sub-módulo.
//
// Um card só no hub do Financeiro, com as duas telas em abas internas
// (Registrar · Consulta) — o padrão dos vizinhos Nulos / Estorno / Petty Cash.
//
// A loja registra a arrecadação guardada no cofre (por banana); o Financeiro
// consolida por competência e repassa ao Instituto Ronald.
//
// ⚠️ `Financeiro` é SOMENTE LEITURA aqui: ele consolida e repassa, não registra
//    (quem guarda é a loja). A aba de registro nem aparece — a trava real é o
//    `authorizeRoles`/`PERFIS_REGISTRO` do backend; aqui é só a aba.
// =====================================================================

const COR = '#0d7a74';       // paleta do Financeiro (verde-petróleo)
const COR_FORTE = '#115e59';
const COR_FUNDO = '#f0fdfa';

const Cofrinho = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRole = perfilNoModulo(user?.perfil, 'financeiro') || '';

    // ⚠️ LISTA, não `===`: quem consolida (Financeiro) lê mas não registra.
    const PERFIS_SO_LEITURA = ['Financeiro'];
    const somenteLeitura = PERFIS_SO_LEITURA.includes(userRole);

    const [aba, setAba] = useState(somenteLeitura ? 'consulta' : 'registrar');

    const estiloAba = (ativa) => ({
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px',
        backgroundColor: ativa ? COR_FUNDO : 'transparent',
        color: ativa ? COR_FORTE : '#64748b',
        border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
        transition: 'all 0.2s', fontSize: 14,
        boxShadow: ativa ? `inset 0 -2px 0 ${COR}` : 'none',
    });

    const conteudo = () => {
        if (somenteLeitura || aba === 'consulta') return <CofrinhoConsulta />;
        return <CofrinhoRegistro onIrParaConsulta={() => setAba('consulta')} />;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div style={{
                display: 'flex', flexWrap: 'wrap', gap: 12,
                borderBottom: '1px solid #e2e8f0', paddingBottom: 16,
            }}>
                {!somenteLeitura && (
                    <button onClick={() => setAba('registrar')} style={estiloAba(aba === 'registrar')}>
                        <ClipboardList size={18} /> Registrar Lançamento
                    </button>
                )}
                <button onClick={() => setAba('consulta')} style={estiloAba(somenteLeitura || aba === 'consulta')}>
                    <PiggyBank size={18} /> Consulta
                </button>
            </div>

            <div style={{ paddingTop: 8 }}>
                {conteudo()}
            </div>
        </div>
    );
};

export default Cofrinho;
